import { render, staticRenderFns } from "./newDailyDPR.vue?vue&type=template&id=1a3e932c&"
import script from "./newDailyDPR.vue?vue&type=script&lang=js&"
export * from "./newDailyDPR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports